import { render, staticRenderFns } from "./BatchRules.vue?vue&type=template&id=21b8d5df"
import script from "./BatchRules.vue?vue&type=script&lang=ts"
export * from "./BatchRules.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports